/* CONNECT — JavaScript du thème (sans dépendance externe) */
(function () {
  'use strict';

  var C = window.CONNECT || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Format monétaire (format défini dans Shopify) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || C.moneyFormat || '{{amount}} €';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou; dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(prec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(re); if (!m) return format;
    var v;
    switch (m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }

  /* ---------- Animations d'apparition ---------- */
  function initReveal(ctx) {
    var els = $$('.js-reveal:not(.is-visible)', ctx);
    if (!els.length) return;
    if (!C.animations || reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Menu mobile ---------- */
  var lastFocus = null;
  function openMenu() {
    var m = $('[data-menu]'); if (!m) return;
    lastFocus = document.activeElement;
    m.hidden = false; document.body.classList.add('is-locked');
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var close = $('[data-menu-close]', m); if (close) close.focus();
  }
  function closeMenu() {
    var m = $('[data-menu]'); if (!m || m.hidden) return;
    m.hidden = true; document.body.classList.remove('is-locked');
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }

  /* ---------- Barre d'annonce ---------- */
  function initAnnounce(ctx) {
    $$('[data-announce]', ctx).forEach(function (bar) {
      var msgs = $$('.announce__msg', bar);
      if (msgs.length < 2 || bar._timer) return;
      var i = 0, ms = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;
      bar._timer = setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, ms);
    });
  }

  /* ---------- Vidéos (lecture auto muette, uniquement visible) ---------- */
  var mqMobile = window.matchMedia('(max-width: 749px)');
  function activeVideo(box) {
    var vids = $$('video.vid__el', box);
    if (vids.length < 2) return vids[0];
    return mqMobile.matches ? $('.vid__el--m', box) : $('.vid__el--d', box);
  }
  function initVideos(ctx) {
    $$('[data-video]', ctx).forEach(function (box) {
      if (box._init) return; box._init = true;
      var auto = box.getAttribute('data-autoplay') === 'true';
      var toggle = $('[data-video-toggle]', box);
      function sync() { var v = activeVideo(box); box.classList.toggle('is-playing', !!(v && !v.paused)); }
      $$('video', box).forEach(function (v) { v.addEventListener('play', sync); v.addEventListener('pause', sync); });
      if (toggle) toggle.addEventListener('click', function () {
        var v = activeVideo(box); if (!v) return;
        if (v.paused) { box._userPaused = false; v.play().catch(function () {}); } else { box._userPaused = true; v.pause(); }
      });
      if (!auto) return;
      if (reduced) { box._userPaused = true; return; }
      if (!('IntersectionObserver' in window)) { var v0 = activeVideo(box); if (v0) { v0.muted = true; v0.play().catch(function () {}); } return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = activeVideo(box); if (!v) return;
          if (e.isIntersecting && !box._userPaused) {
            v.muted = true; if (v.preload === 'none') v.preload = 'auto';
            v.play().catch(function () {});
          } else if (!e.isIntersecting) { v.pause(); }
        });
      }, { threshold: 0.25 }).observe(box);
    });
  }

  /* ---------- Galerie produit ---------- */
  function initGalleries(ctx) {
    $$('[data-gallery]', ctx).forEach(function (g) {
      if (g._init) return; g._init = true;
      var track = $('[data-gallery-track]', g);
      var slides = $$('.pgal__slide', g);
      var dots = $$('[data-gallery-dot]', g);
      function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (getComputedStyle(track).flexDirection === 'column') { slides[i].scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); }
        else track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        mark(i);
      }
      function mark(i) {
        dots.forEach(function (d) { d.classList.toggle('is-active', +d.getAttribute('data-gallery-dot') === i); });
        slides.forEach(function (s, n) { if (n !== i) $$('video', s).forEach(function (v) { v.pause(); }); });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-gallery-dot')); }); });
      var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });
      var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { mark(idx()); }, 80); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
      });
      g._goToMedia = function (id) {
        var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == id; });
        if (i > -1) go(i);
      };
    });
  }

  /* ---------- Quantité ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var box = (minus || plus).closest('[data-qty]'); if (!box) return;
    var input = $('input', box); if (!input) return;
    var min = parseInt(input.min, 10); if (isNaN(min)) min = 1;
    var val = (parseInt(input.value, 10) || 0) + (plus ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Envoi automatique (tri, panier) ---------- */
  var autoTimer;
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-autosubmit]'); if (!el || !el.form) return;
    clearTimeout(autoTimer);
    autoTimer = setTimeout(function () { el.form.submit(); }, el.tagName === 'SELECT' ? 0 : 500);
  });

  /* ---------- Variantes ---------- */
  function initProducts(ctx) {
    $$('[data-product-info]', ctx).forEach(function (root) {
      if (root._init) return; root._init = true;
      var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
      var variants; try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
      var section = root.closest('.shopify-section') || document;
      root.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-index]')) return;
        var selected = [];
        $$('[data-option-index]', root).forEach(function (input) {
          var i = +input.getAttribute('data-option-index');
          if (input.tagName === 'SELECT' || input.checked) selected[i] = input.value;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
        update(v, selected);
      });
      function update(v, selected) {
        selected.forEach(function (val, i) {
          var lbl = $('[data-option-value="' + i + '"]', root); if (lbl) lbl.textContent = val;
        });
        var idInput = $('[data-variant-id]', root);
        var btn = $('[data-add-button]', root);
        var label = btn && $('[data-add-label]', btn);
        if (!v) {
          if (btn) { btn.disabled = true; label.textContent = C.strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (btn) {
          btn.disabled = !v.available;
          label.textContent = v.available ? btn.getAttribute('data-label') : C.strings.soldOut;
        }
        var now = $('[data-price-now]', root), was = $('[data-price-was]', root), wasWrap = $('[data-price-was-wrap]', root), price = $('[data-price]', root);
        if (now) now.textContent = formatMoney(v.price);
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        if (price) price.classList.toggle('is-sale', !!sale);
        if (wasWrap) wasWrap.hidden = !sale;
        if (was) was.textContent = sale ? formatMoney(v.compare_at_price) : '';
        var stock = $('[data-stock]', root);
        if (stock) {
          stock.classList.toggle('is-out', !v.available);
          $('[data-stock-label]', stock).textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out');
        }
        if (v.featured_media) {
          var g = $('[data-gallery]', section);
          if (g && g._goToMedia) g._goToMedia(v.featured_media.id);
        }
        if (document.body.classList.contains('tpl-product') && root.getAttribute('data-url')) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    });
  }

  /* ---------- Panier : ajout AJAX + panier latéral ---------- */
  function drawer() { return $('[data-cart-drawer]'); }
  var drawerFocus = null;
  function openDrawer() {
    var d = drawer(); if (!d) return false;
    drawerFocus = document.activeElement;
    d.hidden = false; document.body.classList.add('is-locked');
    var p = $('.drawer__panel', d); if (p) p.focus();
    return true;
  }
  function closeDrawer() {
    var d = drawer(); if (!d || d.hidden) return;
    d.hidden = true; document.body.classList.remove('is-locked');
    if (drawerFocus) drawerFocus.focus();
  }
  function renderDrawer(html) {
    var d = drawer(); if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]'); if (!fresh) return;
    var wasOpen = !d.hidden;
    d.innerHTML = fresh.innerHTML;
    d.setAttribute('data-count', fresh.getAttribute('data-count'));
    d.hidden = !wasOpen;
    setCount(+fresh.getAttribute('data-count'));
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function drawerSectionId() {
    var d = drawer(); var s = d && d.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : 'cart-drawer';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || C.cartType !== 'drawer' || !drawer()) return;
    e.preventDefault();
    var btn = $('[data-add-button]', form), err = $('[data-form-error]', form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (err) err.hidden = true;
    var fd = new FormData(form);
    fd.append('sections', drawerSectionId());
    fd.append('sections_url', window.location.pathname);
    fetch(C.routes.cartAdd, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (err) { err.textContent = data.description || data.message || C.strings.error; err.hidden = false; }
          return;
        }
        if (data.sections) renderDrawer(data.sections[drawerSectionId()]);
        openDrawer();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  });

  function changeLine(line, qty) {
    var d = drawer(); if (d) d.classList.add('is-busy');
    fetch(C.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +line, quantity: Math.max(0, +qty), sections: [drawerSectionId()], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data.sections) renderDrawer(data.sections[drawerSectionId()]); })
      .catch(function () { window.location.href = C.routes.cart; })
      .finally(function () { var dd = drawer(); if (dd) dd.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { openMenu(); return; }
    if (e.target.closest('[data-menu-close]')) { closeMenu(); return; }
    var opener = e.target.closest('[data-cart-open]');
    if (opener && C.cartType === 'drawer' && drawer() && !document.body.classList.contains('tpl-cart')) {
      e.preventDefault(); openDrawer(); return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    var lc = e.target.closest('[data-line-change]');
    if (lc) { changeLine(lc.getAttribute('data-line-change'), lc.getAttribute('data-qty')); return; }
    // Fermer les menus déroulants ouverts quand on clique ailleurs
    $$('.hdr__dd[open]').forEach(function (dd) { if (!dd.contains(e.target)) dd.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMenu(); closeDrawer();
    $$('.hdr__dd[open]').forEach(function (dd) { dd.removeAttribute('open'); });
  });
  mqMobile.addEventListener && mqMobile.addEventListener('change', function (e) { if (!e.matches) closeMenu(); });

  /* ---------- Initialisation ---------- */
  function init(ctx) {
    initReveal(ctx); initAnnounce(ctx); initVideos(ctx); initGalleries(ctx); initProducts(ctx);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Éditeur de thème : réinitialiser les sections rechargées
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var g = e.target.closest('[data-gallery]'); if (g) return;
    var msg = e.target.closest('.announce__msg');
    if (msg) { $$('.announce__msg', msg.parentNode).forEach(function (m) { m.classList.toggle('is-active', m === msg); }); }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openDrawer();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) closeDrawer();
  });

  window.CONNECT.formatMoney = formatMoney;
})();
